import { render } from "./ProfileRates.vue?vue&type=template&id=3fad2ca0&scoped=true"
import script from "./ProfileRates.vue?vue&type=script&lang=js"
export * from "./ProfileRates.vue?vue&type=script&lang=js"

import "./ProfileRates.vue?vue&type=style&index=0&id=3fad2ca0&scoped=true&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fad2ca0"]])

export default __exports__